(() => {
  const CACHE_KEY = 'gos-format-products-v2';
  const normalize = value => String(value || '').toLowerCase().replace(/[’']/g, "'").replace(/\s+/g, ' ').trim();
  const tags = product => Array.isArray(product.tags) ? product.tags.map(normalize) : String(product.tags || '').split(',').map(normalize);
  const formatOf = product => {
    const title = String(product.title || '');
    const productTags = tags(product);
    if (/\brefill\b/i.test(title) || productTags.includes('refill')) return 'refill';
    if (/\bsample\b/i.test(title) || productTags.includes('sample')) return 'sample';
    return 'bottle';
  };
  const baseTitle = value => String(value || '')
    .replace(/\s*,?\s*refill\s*(?:\([^)]*\))?\s*$/i, '')
    .replace(/\s*[-–—,]?\s*(?:sample|sample size)\s*(?:\([^)]*\))?\s*$/i, '')
    .replace(/\s*\((?:sample|sample size)\)\s*$/i, '')
    .replace(/\s*,\s*$/, '')
    .trim();
  const baseKey = value => normalize(baseTitle(value)).replace(/[^a-z0-9]+/g, ' ').trim();
  const escapeHTML = value => String(value || '').replace(/[&<>'"]/g, character => ({
    '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'
  })[character]);

  const readCache = () => {
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      return Array.isArray(cached) ? cached : null;
    } catch (_) { return null; }
  };
  const writeCache = products => {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(products)); } catch (_) {}
  };
  const fetchPage = page => fetch('/products.json?limit=250&page=' + page, {
    credentials: 'same-origin',
    cache: 'force-cache'
  }).then(response => response.ok ? response.json() : Promise.reject(new Error('Product request failed')))
    .then(payload => Array.isArray(payload.products) ? payload.products : []);

  let catalogPromise;
  const loadCatalog = () => {
    if (catalogPromise) return catalogPromise;
    const cached = readCache();
    if (cached) return (catalogPromise = Promise.resolve(cached));
    catalogPromise = Promise.all([fetchPage(1), fetchPage(2)]).then(async pages => {
      const products = pages.flat();
      if (pages[1].length >= 250) {
        for (let page = 3; page <= 6; page += 1) {
          const batch = await fetchPage(page);
          products.push(...batch);
          if (batch.length < 250) break;
        }
      }
      const unique = [...new Map(products.filter(product => product && product.handle).map(product => [product.handle, product])).values()];
      writeCache(unique);
      return unique;
    });
    return catalogPromise;
  };

  const rank = { bottle: 0, refill: 1, sample: 2 };
  const label = format => format === 'refill' ? 'Refill' : format.charAt(0).toUpperCase() + format.slice(1);

  const initialize = async root => {
    if (!root || root.dataset.gosReady === 'true') return;
    root.dataset.gosReady = 'true';
    const grid = root.querySelector('[data-gos-format-grid]');
    const currentNode = root.querySelector('[data-gos-current-product]');
    if (!grid || !currentNode) return;
    let currentProduct;
    try { currentProduct = JSON.parse(currentNode.textContent || '{}'); } catch (_) { currentProduct = {}; }
    const currentKey = baseKey(currentProduct.title || document.querySelector('.product__title')?.textContent);
    if (!currentKey) return root.remove();

    try {
      const products = await loadCatalog();
      const byFormat = new Map();
      products.filter(product => baseKey(product.title) === currentKey).forEach(product => {
        const format = formatOf(product);
        const existing = byFormat.get(format);
        if (!existing || product.handle === root.dataset.currentHandle) byFormat.set(format, product);
      });
      if (currentProduct.handle && ![...byFormat.values()].some(product => product.handle === currentProduct.handle)) {
        byFormat.set(formatOf(currentProduct), currentProduct);
      }
      const options = [...byFormat.entries()].sort((a, b) => rank[a[0]] - rank[b[0]]);
      if (options.length < 2) return root.remove();
      grid.innerHTML = options.map(([format, product]) => {
        const current = product.handle === root.dataset.currentHandle;
        return '<a class="gos-format-pill' + (current ? ' is-current' : '') + '" href="/products/' +
          escapeHTML(product.handle) + '"' + (current ? ' aria-current="page"' : '') + '>' +
          escapeHTML(label(format)) + '</a>';
      }).join('');
      root.classList.remove('is-discovering');
    } catch (_) {
      if (grid.querySelectorAll('.gos-format-pill').length > 1) root.classList.remove('is-discovering');
      else root.remove();
    }
  };

  const initializeAll = () => document.querySelectorAll('[data-gos-format-selector]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  initializeAll();
})();
